import { Component, Input } from '@angular/core';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { has } from 'lodash';

@Component({
    selector: 'ag-grid-filter-toggle',
    templateUrl: './agGridFilterToggle.component.html',
    standalone: false
})
export class AgGridFilterToggleComponent {
    @Input() gridApi: GridApi;

    private _showFloatingFilter: boolean;

    get isFilterVisible(): boolean {
        return this.gridApi && this._showFloatingFilter;
    }

    onFilterClick() {
        this._showFloatingFilter = !this._showFloatingFilter;

        const colDefs: ColDef[] = this.gridApi.getColumnDefs();
        colDefs.forEach(x => x.floatingFilter = this._showFloatingFilter);
        this.gridApi.updateGridOptions({ columnDefs: colDefs });

        this.gridApi.refreshHeader();

        // clear filter when hiding
        if (!this._showFloatingFilter && this._isFiltered()) {
            this.gridApi.setFilterModel(null);
            this.gridApi.onFilterChanged();
        }
    }

    private _isFiltered(): boolean {
        const filterModel = this.gridApi.getFilterModel();
        if (!filterModel) {
            return false;
        }

        // filter model is an empty object when not filtered
        for (const key in filterModel) {
            if (has(filterModel, key)) {
                return true;
            }
        }

        return false;
    }
}
